import React from 'react';
import type { FC } from 'react';

import styled from '@emotion/styled';

import { Box, Text, mq } from '@clutter/clean';

import { Location__Service } from '@graphql/platform';

import MOVER_WITH_TWENTY_FOOT_TRUCK from '@images/illustrations/mover_with_twenty_foot_truck.svg';
import ONLINE_PHOTO_CATALOG_SMALL from '@images/illustrations/online_photo_catalog_small.svg';
import SAVING_COINS_SMALL from '@images/illustrations/saving_coins_small.svg';
import STORAGE_FACILITY from '@images/illustrations/storage_facility.svg';

import { Section } from './section';

const MOVING_ITEMS = [
  {
    title: 'No More Driving - We handle pickup & delivery',
    icon: MOVER_WITH_TWENTY_FOOT_TRUCK,
  },
  {
    title: 'No hidden charges',
    icon: SAVING_COINS_SMALL,
  },
  {
    title: 'Free month of storage included',
    icon: STORAGE_FACILITY,
  },
  {
    title: 'Digital tracking of your move',
    icon: ONLINE_PHOTO_CATALOG_SMALL,
  },
];

const STORAGE_ITEMS = [
  {
    title: 'No More Driving - We handle pickup & delivery',
    icon: MOVER_WITH_TWENTY_FOOT_TRUCK,
  },
  {
    title: 'No hidden charges',
    icon: SAVING_COINS_SMALL,
  },
  {
    title: 'Temperature control & secure warehouse',
    icon: STORAGE_FACILITY,
  },
  {
    title: 'Digital Inventory for easy access',
    icon: ONLINE_PHOTO_CATALOG_SMALL,
  },
];

const Title = styled(Text.Title)`
  text-align: center;
`;

const Grid = styled.div`
  display: grid;
  gap: 32px;

  ${mq({
    gridTemplateColumns: ['1fr', '1fr 1fr', null, '1fr 1fr 1fr 1fr'],
  })}
`;

const NAME: Record<Location__Service, string> = {
  [Location__Service.SelfStorage]: 'Store',
  [Location__Service.SmartStorage]: 'Store',
  [Location__Service.Moving]: 'Move',
};

export const SectionTheNewWayToStore: FC<{
  service: Location__Service;
}> = ({ service }) => (
  <Section padding="0 0 80px">
    <Box.Flex flexDirection="column" alignItems="center" gap="32px">
      <Title size="large" tag="h2">
        Clutter: The New Way to {NAME[service]}
      </Title>
      <Grid>
        {(service === Location__Service.Moving
          ? MOVING_ITEMS
          : STORAGE_ITEMS
        ).map((item, index) => (
          <Box.Flex
            key={index}
            flexDirection="column"
            alignItems="center"
            gap="32px"
          >
            <img
              loading="lazy"
              alt=""
              style={{ height: '96px', width: 'auto' }}
              src={item.icon}
            />
            <Title size="extraSmall">{item.title}</Title>
          </Box.Flex>
        ))}
      </Grid>
    </Box.Flex>
  </Section>
);
